import type { AvailableDose } from '~/hooks/dose/useAvailableDoses';

/**
 * The label a dose is shown with: its plan label, else its summation type,
 * else "Dose". One function, so every place that names a dose names it the
 * same way.
 */
export function getDoseLabel(
    planLabel?: string,
    summationType?: string
): string {
    return planLabel ?? summationType ?? 'Dose';
}

/** The name of an available dose: its plan's label, else its summation type. */
export function doseNameOf({ label, item }: AvailableDose): string {
    return getDoseLabel(label, item?.doseSummationType);
}
